

export const Divider = () => {
  return (
    <div
        className="border-t-2"
    ></div>
  )
}
